var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"start-trip-card",on:{"click":_vm.goToDiscover}},[_c('transition',{attrs:{"name":"fade-in"}},[_c('div',{staticClass:"start-trip-card__content"},[_c('span',[_vm._v("+")]),_vm._v(" Start a New Trip ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }